import { render } from "./Reports.vue?vue&type=template&id=3b4f859f&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=3b4f859f&scoped=true&lang=css"
import "./Reports.vue?vue&type=style&index=1&id=3b4f859f&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4f859f"]])

export default __exports__